import React, { useMemo, useState } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";

export default function BranchesMap({ branches }) {
    const [selectedId, setSelectedId] = useState(branches?.[0]?.id);

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    });

    const selected = branches.find((b) => b.id === selectedId) || branches[0];

    const center = useMemo(() => {
        return selected
            ? { lat: selected.lat, lng: selected.lng }
            : { lat: 41.0896633, lng: 31.1302742 };
    }, [selected]);

    if (loadError) return <div className="container">Harita yüklenemedi.</div>;
    if (!isLoaded) return <div className="container">Harita yükleniyor…</div>;

    return (
        <div className="branchesWrap">
            <div className="container">
                <div className="mapBox">
                    <GoogleMap
                        center={center}
                        zoom={14}
                        mapContainerClassName="mapContainer"
                        options={{
                            fullscreenControl: true,
                            streetViewControl: false,
                            mapTypeControl: false,
                            clickableIcons: false,
                        }}
                    >
                        {branches.map((b) => (
                            <Marker
                                key={b.id}
                                position={{ lat: b.lat, lng: b.lng }}
                                onClick={() => setSelectedId(b.id)}
                            />
                        ))}
                    </GoogleMap>
                </div>
            </div>

            <div className="branchesCardsFull">
                <div className="containerWide branchesCards">
                    {branches.map((b) => (
                        <div
                            key={b.id}
                            className={`branchCard branchCardRow ${b.id === selectedId ? "isActive" : ""
                                }`}
                        >
                            <div className="branchImage">
                                <img src={b.image} alt={b.name} />
                            </div>

                            <div className="branchContent">
                                <div className="branchTitle">{b.name}</div>
                                <div className="branchText"><span className="address">Adres:</span> {b.address}</div>
                                <div className="branchText"><span className="phone">Telefon:</span>{b.phone}</div>

                                <div className="branchActions">
                                    <a
                                        className="branchLink branchCall"
                                        href={`tel:${b.phone.replace(/\s/g, "")}`}
                                    >
                                        Ara
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </div>
    );
}
